import { useMusic } from "@/music";
import { useLang } from "@/i18n";
import { Music } from "lucide-react";

export const MusicPicker = () => {
  const { songs, songId, setSongId } = useMusic();
  const { t } = useLang();
  const options = [{ id: "auto", name: t("autoMusic") }, ...songs];
  return (
    <div className="flex items-center gap-3 w-full max-w-xs justify-center" data-testid="music-picker">
      <p className="font-pixel text-[11px] text-[#FFEB3B] flex items-center gap-2 pixel-stroke whitespace-nowrap">
        <Music size={14} strokeWidth={3} /> {t("music")}
      </p>
      <select
        data-testid="music-select"
        value={songId}
        onChange={(e) => setSongId(e.target.value)}
        className="font-vt text-base px-3 py-2 rounded-xl cursor-pointer flex-1"
        style={{ background: "rgba(0,0,0,0.55)", color: "#fff", border: "2px solid rgba(255,255,255,0.25)" }}
      >
        {options.map((s) => (
          <option key={s.id} value={s.id} style={{ color: "#000" }} data-testid={`song-${s.id}`}>
            {s.name}
          </option>
        ))}
      </select>
    </div>
  );
};
